import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import tradeDataStore from "@/store/tradeDataStore";
import { getLegSummaryDataFromStore } from "./fillsSummaryHelpers";
import PercentBar from "@/components/UI/PercentBar";

/**
 * FillsSummaryPercentCellRenderer
 *
 * Displays a progress bar showing the total filled percentage at the leg level.
 * - Main display: Shows block value from API (current server state)
 * - Tooltip: Handled by tooltipValueGetter on the column definition
 *
 * - Green portion: filled amount
 * - Red portion: unfilled amount
 * - Percentage (rounded) displayed inside the bar
 */
const FillsSummaryPercentCellRenderer = (params: any) => {
  // Subscribe to Zustand store for reactive updates (hooks must run before any early return)
  tradeDataStore((state) => state.tradeData);

  if (!params.data) {
    return null;
  }

  const { fullTradeData } = returnAllTradeDetailsFromGenericParams(params);
  const esid = fullTradeData?.esid;
  const blockId = params.data?.blockId;

  let percentFilled = 0;

  if (esid && blockId !== undefined) {
    const legData = getLegSummaryDataFromStore(esid, blockId, params.data);
    percentFilled = legData.percentFilled ?? 0;
  }

  return (
    <PercentBar
      percent={percentFilled}
      testId="fillsSummaryPercentCellContainer"
    />
  );
};

export default FillsSummaryPercentCellRenderer;

/**
 * AG Grid valueFormatter for copy/paste functionality.
 * Returns the percentFilled from the legs array.
 */
export function fillsSummaryPercentValueFormatter(params: any): string {
  if (!params.data) {
    return "";
  }

  const { fullTradeData } = returnAllTradeDetailsFromGenericParams(params);
  const esid = fullTradeData?.esid;
  const blockId = params.data?.blockId;

  if (!esid || blockId === undefined) {
    return "";
  }

  const legData = getLegSummaryDataFromStore(esid, blockId, params.data);
  const percentFilled = legData.percentFilled ?? 0;
  const displayPercent = Math.round(percentFilled);

  return `${displayPercent} `;
}
